(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["gb-collapsible-block"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gb-collapsible-block')) {
    class GbCollapsibleBlock extends HTMLElement {
      connectedCallback() {
        this.root = this.querySelector('.gb-collapsible-block');
        this.button = this.querySelector('.gb-collapsible-block__header');
        this.panel = this.querySelector('.gb-collapsible-block__panel');

        if (!this.root || !this.button || !this.panel) return;

        this.onToggle = this.onToggle.bind(this);
        this.button.addEventListener('click', this.onToggle);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onToggle);
      }

      onToggle() {
        const isOpen = !this.root.classList.contains('is-open');

        this.root.classList.toggle('is-open', isOpen);
        this.button.setAttribute('aria-expanded', String(isOpen));
        this.panel.setAttribute('aria-hidden', String(!isOpen));
      }
    }

    customElements.define('gb-collapsible-block', GbCollapsibleBlock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gb-popup-slide-block"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gb-popup-slide-block')) {
    class GbPopupSlideBlock extends HTMLElement {
      static TRANSITION_MS = 300;

      connectedCallback() {
        this.trigger = this.querySelector('.gb-popup-slide-block__trigger');
        this.overlay = this.querySelector('.gb-popup-slide-block__overlay');
        this.panel = this.querySelector('.gb-popup-slide-block__panel');
        this.closeBtn = this.querySelector('.gb-popup-slide-block__close');

        if (!this.trigger || !this.overlay || !this.panel) return;

        this._onTriggerClick = this.onTriggerClick.bind(this);
        this._onCloseClick = this.onCloseClick.bind(this);
        this._onOverlayClick = this.onOverlayClick.bind(this);
        this._onKeydown = this.onKeydown.bind(this);
        this._onOverlayTransitionEnd = this.onOverlayTransitionEnd.bind(this);

        this.trigger.addEventListener('click', this._onTriggerClick);
        this.closeBtn?.addEventListener('click', this._onCloseClick);
        this.overlay.addEventListener('click', this._onOverlayClick);

        if (this.dataset.openByDefault === 'true') {
          this.trigger.setAttribute('aria-expanded', 'true');
          this.lockScroll();
          document.addEventListener('keydown', this._onKeydown);
        }
      }

      disconnectedCallback() {
        this.trigger?.removeEventListener('click', this._onTriggerClick);
        this.closeBtn?.removeEventListener('click', this._onCloseClick);
        this.overlay?.removeEventListener('click', this._onOverlayClick);
        this.overlay?.removeEventListener('transitionend', this._onOverlayTransitionEnd);
        clearTimeout(this._closeTimer);
        document.removeEventListener('keydown', this._onKeydown);
        this.unlockScroll();
      }

      isOpen() {
        return this.classList.contains('is-open');
      }

      onTriggerClick(event) {
        if (this.trigger.target === '_blank') return;
        event.preventDefault();
        this.open();
      }

      onCloseClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.close();
      }

      onOverlayClick(event) {
        if (event.target !== this.overlay) return;
        this.close();
      }

      onKeydown(event) {
        if (event.key === 'Escape' && this.isOpen()) {
          event.preventDefault();
          this.close();
        }
      }

      onOverlayTransitionEnd(event) {
        if (event.target !== this.overlay || this.isOpen()) return;
        this.hideOverlay();
      }

      showOverlay() {
        this.overlay.hidden = false;
      }

      hideOverlay() {
        this.overlay.hidden = true;
        this.overlay.removeEventListener('transitionend', this._onOverlayTransitionEnd);
        clearTimeout(this._closeTimer);
        this._closeTimer = null;
      }

      lockScroll() {
        document.documentElement.style.overflow = 'hidden';
      }

      unlockScroll() {
        if (!document.querySelector('gb-popup-slide-block.is-open')) {
          document.documentElement.style.overflow = '';
        }
      }

      open() {
        if (this.isOpen()) return;

        clearTimeout(this._closeTimer);
        this.overlay.removeEventListener('transitionend', this._onOverlayTransitionEnd);
        this.showOverlay();

        requestAnimationFrame(() => {
          this.classList.add('is-open');
          this.overlay.setAttribute('aria-hidden', 'false');
          this.trigger.setAttribute('aria-expanded', 'true');
          this.lockScroll();
          document.addEventListener('keydown', this._onKeydown);
          requestAnimationFrame(() => this.panel.focus());
        });
      }

      close() {
        if (!this.isOpen()) return;

        this.classList.remove('is-open');
        this.overlay.setAttribute('aria-hidden', 'true');
        this.trigger.setAttribute('aria-expanded', 'false');
        document.removeEventListener('keydown', this._onKeydown);
        this.unlockScroll();
        this.trigger.focus();

        this.overlay.addEventListener('transitionend', this._onOverlayTransitionEnd);
        this._closeTimer = setTimeout(() => {
          if (!this.isOpen()) this.hideOverlay();
        }, GbPopupSlideBlock.TRANSITION_MS);
      }
    }

    customElements.define('gb-popup-slide-block', GbPopupSlideBlock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gb-size-fit-tool"] && !Shopify.designMode) return;
  try {
    class GbSizeFitTool {
    constructor(root) {
      this.root = root;
      this.config = JSON.parse(root.querySelector('[data-sft-config]').textContent);
      this.unitSelect = root.querySelector('[data-sft-unit]');
      this.inchesGroup = root.querySelector('[data-sft-inches-group]');
      this.feetSelect = root.querySelector('[data-sft-feet]');
      this.inchSelect = root.querySelector('[data-sft-inches]');
      this.cmSelect = root.querySelector('[data-sft-cm]');
      this.recommendation = root.querySelector('[data-sft-recommendation]');
      this.recommendationTitle = root.querySelector('[data-sft-recommendation-title]');
      this.recommendationBody = root.querySelector('[data-sft-recommendation-body]');
      this.sizeRows = [...root.querySelectorAll('[data-sft-size-row]')];
      this.overlapTemplates = [...root.querySelectorAll('[data-sft-overlap-template]')];
      this.noMatchTemplate = root.querySelector('[data-sft-no-match-template]');
      this.globalHeightMinLabel = root.querySelector('[data-sft-global-height-min]');
      this.globalHeightMaxLabel = root.querySelector('[data-sft-global-height-max]');
      this.chart = root.querySelector('[data-sft-chart]');
      this.currentHeightMarker = root.querySelector('[data-sft-current-height-marker]');
      this.isDragging = false;

      this.bindEvents();
      this.onUnitChange();
    }

    bindEvents() {
      if (!this.config.disableUnitSwitch) {
        this.unitSelect.addEventListener('change', () => this.onUnitChange());
      }
      this.feetSelect.addEventListener('change', () => {
        this.syncInchesOptions();
        this.update();
      });
      this.inchSelect.addEventListener('change', () => this.update());
      this.cmSelect.addEventListener('change', () => this.update());
      this.initMarkerDrag();
    }

    onUnitChange() {
      const isInches = this.unitSelect.value === 'inches';
      this.inchesGroup.hidden = !isInches;
      this.cmSelect.hidden = isInches;
      this.update();
    }

    getCurrentHeightCm() {
      if (this.unitSelect.value === 'cm') {
        return Number(this.cmSelect.value);
      }

      const feet = Number(this.feetSelect.value);
      const inches = Number(this.inchSelect.value);
      return this.getCmFromInches(feet, inches);
    }

    clampHeightCm(cm) {
      return Math.max(this.config.minHeightCm, Math.min(this.config.maxHeightCm, Math.round(cm)));
    }

    getCmFromInches(feet, inches) {
      // return Math.round((feet * 12 + inches) * 2.54);
      return Math.floor((feet * 12 + inches) * 2.54);
    }

    isHeightCmInRange(cm) {
      return cm >= this.config.minHeightCm && cm <= this.config.maxHeightCm;
    }

    syncFeetOptions() {
      [...this.feetSelect.options].forEach((footOption) => {
        const feet = Number(footOption.value);
        const hasValidInch = [...this.inchSelect.options].some((inchOption) =>
          this.isHeightCmInRange(this.getCmFromInches(feet, Number(inchOption.value)))
        );

        footOption.hidden = !hasValidInch;
        footOption.disabled = !hasValidInch;
      });

      const validFeetOptions = [...this.feetSelect.options].filter((option) => !option.hidden);
      if (validFeetOptions.length && !validFeetOptions.some((option) => option.selected)) {
        validFeetOptions[0].selected = true;
      }
    }

    syncInchesOptions() {
      const feet = Number(this.feetSelect.value);

      [...this.inchSelect.options].forEach((inchOption) => {
        const inches = Number(inchOption.value);
        const isValid = this.isHeightCmInRange(this.getCmFromInches(feet, inches));

        inchOption.hidden = !isValid;
        inchOption.disabled = !isValid;
      });

      const validInchOptions = [...this.inchSelect.options].filter((option) => !option.hidden);
      if (validInchOptions.length && !validInchOptions.some((option) => option.selected)) {
        validInchOptions[0].selected = true;
      }
    }

    syncHeightSelectOptions() {
      this.syncFeetOptions();
      this.syncInchesOptions();
    }

    setHeightFromCm(cm) {
      const clamped = this.clampHeightCm(cm);

      if ([...this.cmSelect.options].some((option) => option.value === String(clamped))) {
        this.cmSelect.value = String(clamped);
      }

      this.setInchesFromCm(clamped);
      return clamped;
    }

    setInchesFromCm(cm) {
      const totalInches = Math.round(cm / 2.54);
      const feet = Math.floor(totalInches / 12);
      const inches = totalInches % 12;

      if ([...this.feetSelect.options].some((option) => option.value === String(feet))) {
        this.feetSelect.value = String(feet);
      }

      this.inchSelect.value = String(inches);
    }

    getCmFromChartRatio(ratio) {
      const { minHeightCm, maxHeightCm } = this.config;
      return this.clampHeightCm(minHeightCm + ratio * (maxHeightCm - minHeightCm));
    }

    getChartRatioFromCm(cm) {
      const { minHeightCm, maxHeightCm } = this.config;
      if (maxHeightCm <= minHeightCm) return 0;
      return (this.clampHeightCm(cm) - minHeightCm) / (maxHeightCm - minHeightCm);
    }

    initMarkerDrag() {
      if (!this.chart || !this.currentHeightMarker) return;

      const marker = this.currentHeightMarker;

      const onPointerDown = (event) => {
        event.preventDefault();
        marker.setPointerCapture(event.pointerId);
        marker.classList.add('is-dragging');
        this.isDragging = true;
        this.setHeightFromChartPointer(event);
      };

      const onPointerMove = (event) => {
        if (!this.isDragging) return;
        this.setHeightFromChartPointer(event);
      };

      const endDrag = (event) => {
        if (!this.isDragging) return;
        this.isDragging = false;
        marker.classList.remove('is-dragging');
        if (marker.hasPointerCapture(event.pointerId)) {
          marker.releasePointerCapture(event.pointerId);
        }
      };

      marker.addEventListener('pointerdown', onPointerDown);
      marker.addEventListener('pointermove', onPointerMove);
      marker.addEventListener('pointerup', endDrag);
      marker.addEventListener('pointercancel', endDrag);
    }

    setHeightFromChartPointer(event) {
      const rect = this.chart
        .querySelector('.gb-size-fit-tool__current-height-marker-container')
        .getBoundingClientRect();
      const ratio = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
      this.setHeightFromCm(this.getCmFromChartRatio(ratio));
      this.update();
    }

    formatHeight(cm) {
      if (this.unitSelect.value === 'cm') {
        return `${cm}cm`;
      }

      const totalInches = Math.round(cm / 2.54);
      const feet = Math.floor(totalInches / 12);
      const inches = totalInches % 12;
      return `${feet}'${inches}"`;
    }

    formatInseam(cm) {
      if (this.unitSelect.value === 'cm') {
        return `${cm} cm`;
      }

      const totalInches = Math.round(cm / 2.54);
      const feet = Math.floor(totalInches / 12);
      const inches = totalInches % 12;

      if (feet > 0) {
        return `${feet}'${inches}"`;
      }

      return `${inches}"`;
    }

    formatRange(minCm, maxCm, formatter) {
      const format = (value) => formatter.call(this, value).replace(/"/g, '\u2033');
      return `${format(minCm)}-${format(maxCm)}`;
    }

    getGlobalPosition(value, globalMin, globalMax) {
      if (globalMax <= globalMin) return 0;
      const ratio = (value - globalMin) / (globalMax - globalMin);
      return Math.max(0, Math.min(100, ratio * 100));
    }

    applySegmentPosition(segment, min, max, globalMin, globalMax) {
      const left = this.getGlobalPosition(min, globalMin, globalMax);
      const right = this.getGlobalPosition(max, globalMin, globalMax);
      segment.style.left = `${left}%`;
      segment.style.width = `${Math.max(0, right - left)}%`;
    }

    applyCustomSegmentPosition(segment, left, right) {
      const clampedLeft = Math.max(0, Math.min(100, left));
      const clampedRight = Math.max(clampedLeft, Math.min(100, right));
      segment.style.left = `${clampedLeft}%`;
      segment.style.width = `${clampedRight - clampedLeft}%`;
    }

    getSizeRowByIndex(index) {
      return this.sizeRows.find((row) => Number(row.dataset.sizeIndex) === index);
    }

    findAdjacentOverlapPair(matchedIndices) {
      for (let index = 1; index <= 3; index += 1) {
        if (matchedIndices.includes(index) && matchedIndices.includes(index + 1)) {
          return `${index}-${index + 1}`;
        }
      }
      return null;
    }

    getOverlapTemplate(pair) {
      return this.overlapTemplates.find((template) => template.dataset.overlapPair === pair);
    }

    hasRichTextContent(html) {
      const text = html
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/gi, ' ')
        .trim();
      return text.length > 0;
    }

    showRecommendation({ title, bodyHtml }) {
      this.recommendation.hidden = false;
      this.recommendationTitle.textContent = title;
      this.recommendationBody.innerHTML = bodyHtml;
    }

    hideRecommendation() {
      this.recommendation.hidden = true;
      this.recommendationTitle.textContent = '';
      this.recommendationBody.innerHTML = '';
    }

    update() {
      if (this.unitSelect.value === 'inches') {
        this.syncHeightSelectOptions();
      }

      // const currentCm = this.setHeightFromCm(this.getCurrentHeightCm());
      const currentCm = Math.floor(this.setHeightFromCm(this.getCurrentHeightCm()));
      console.log('currentCm', currentCm);

      if (this.unitSelect.value === 'inches') {
        this.syncInchesOptions();
      }
      const globalHeightMin = this.config.minHeightCm;
      const globalHeightMax = this.config.maxHeightCm;
      const matchedIndices = [];
      let matchedRow = null;

      if (this.globalHeightMinLabel) {
        this.globalHeightMinLabel.textContent = this.formatHeight(globalHeightMin);
      }

      if (this.globalHeightMaxLabel) {
        this.globalHeightMaxLabel.textContent = this.formatHeight(globalHeightMax);
      }

      const currentHeightMarkerValue = this.currentHeightMarker.querySelector('[data-sft-current-height-marker-value]');
      this.currentHeightMarker.hidden = false;
      currentHeightMarkerValue.textContent = this.formatHeight(currentCm);
      this.currentHeightMarker.style.left = `${this.getChartRatioFromCm(currentCm) * 100}%`;

      this.sizeRows.forEach((row) => {
        const heightMin = Number(row.dataset.heightMin);
        const heightMax = Number(row.dataset.heightMax);
        const inseamMin = Number(row.dataset.inseamMin);
        const inseamMax = Number(row.dataset.inseamMax);
        const inseamLeft = Number(row.dataset.inseamLeft);
        const inseamRight = Number(row.dataset.inseamRight);
        const isMatch = currentCm >= heightMin && currentCm <= heightMax;

        row.classList.toggle('is-match', isMatch);

        const matchLabel = row.querySelector('[data-sft-match-label]');
        const matchText = row.querySelector('[data-sft-match-text]');
        matchLabel.hidden = !isMatch;
        if (isMatch && matchText) {
          matchText.textContent = this.config.matchLabel;
        }

        const sizeRangeHeight = row.querySelector('[data-sft-size-range-height]');
        const sizeRangeInseam = row.querySelector('[data-sft-size-range-inseam]');

        if (sizeRangeHeight) {
          sizeRangeHeight.textContent = `${this.config.heightRangeLabel}: ${this.formatRange(
            heightMin,
            heightMax,
            this.formatHeight
          )}`;
        }

        if (sizeRangeInseam && inseamMax > 0) {
          sizeRangeInseam.textContent = `${this.config.inseamRangeLabel}: ${this.formatRange(
            inseamMin,
            inseamMax,
            this.formatInseam
          )}`;
        }

        const heightSegment = row.querySelector('[data-sft-height-segment]');
        const heightStart = row.querySelector('[data-sft-height-start]');
        const heightEnd = row.querySelector('[data-sft-height-end]');
        heightStart.textContent = this.formatHeight(heightMin);
        heightEnd.textContent = this.formatHeight(heightMax);
        this.applySegmentPosition(heightSegment, heightMin, heightMax, globalHeightMin, globalHeightMax);

        const marker = row.querySelector('[data-sft-height-marker]');
        const markerValue = row.querySelector('[data-sft-height-marker-value]');
        marker.hidden = false;
        markerValue.textContent = this.formatHeight(currentCm);
        marker.style.left = `${this.getGlobalPosition(currentCm, globalHeightMin, globalHeightMax)}%`;

        const inseamSegment = row.querySelector('[data-sft-inseam-segment]');
        const inseamStart = row.querySelector('[data-sft-inseam-start]');
        const inseamEnd = row.querySelector('[data-sft-inseam-end]');

        if (inseamSegment && inseamStart && inseamEnd && inseamMax > 0 && inseamRight > inseamLeft) {
          inseamStart.textContent = this.formatInseam(inseamMin);
          inseamEnd.textContent = this.formatInseam(inseamMax);
          this.applyCustomSegmentPosition(inseamSegment, inseamLeft, inseamRight);
        }

        if (isMatch) {
          matchedIndices.push(Number(row.dataset.sizeIndex));
          if (!matchedRow) {
            matchedRow = row;
          }
        }
      });

      const overlapPair = this.findAdjacentOverlapPair(matchedIndices);
      const overlapTemplate = overlapPair ? this.getOverlapTemplate(overlapPair) : null;
      const overlapHtml = overlapTemplate ? overlapTemplate.innerHTML : '';

      if (overlapPair && this.hasRichTextContent(overlapHtml)) {
        const [firstIndex, secondIndex] = overlapPair.split('-').map(Number);
        const firstRow = this.getSizeRowByIndex(firstIndex);
        const secondRow = this.getSizeRowByIndex(secondIndex);
        const title = [firstRow, secondRow]
          .filter(Boolean)
          .map((row) => row.dataset.recommendationTitle)
          .join(' / ');

        this.showRecommendation({ title, bodyHtml: overlapHtml });
      } else if (matchedRow) {
        const template = matchedRow.querySelector('[data-sft-recommendation-template]');
        this.showRecommendation({
          title: matchedRow.dataset.recommendationTitle,
          bodyHtml: template ? template.innerHTML : '',
        });
      } else {
        const noMatchHtml = this.noMatchTemplate ? this.noMatchTemplate.innerHTML : '';

        if (this.hasRichTextContent(noMatchHtml)) {
          this.showRecommendation({
            title: this.config.noMatchLabel,
            bodyHtml: noMatchHtml,
          });
        } else {
          this.hideRecommendation();
        }
      }
    }
  }

  document.querySelectorAll('.gb-size-fit-tool-block').forEach((block) => {
    new GbSizeFitTool(block);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gb-video-review-item-v1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gb-video-review-item-v1')) {
    class GbVideoReviewItemV1 extends HTMLElement {
      connectedCallback() {
        this.inner = this.querySelector('.gb-video-review-item-v1-inner');
        this.hoverWrap = this.querySelector('.gb-video-review-item-v1-hover-video');
        this.video = this.querySelector('.gb-video-review-item-v1-hover-video video');
        this.playBtn = this.querySelector('.gb-video-review-item-v1-play-btn');

        if (!this.inner || !this.video) return;

        this.onEnter = this.onEnter.bind(this);
        this.onLeave = this.onLeave.bind(this);
        this.inner.addEventListener('mouseenter', this.onEnter);
        this.inner.addEventListener('mouseleave', this.onLeave);
      }

      disconnectedCallback() {
        this.inner?.removeEventListener('mouseenter', this.onEnter);
        this.inner?.removeEventListener('mouseleave', this.onLeave);
      }

      ensureVideoLoaded() {
        if (this.video.dataset.hydrated) return;

        this.video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.getAttribute('data-src');
          source.removeAttribute('data-src');
        });
        this.video.load();
        this.video.dataset.hydrated = 'true';
      }

      playVideo() {
        this.ensureVideoLoaded();
        const play = () => {
          this.video.play().catch((error) => {
            if (error.name !== 'AbortError') {
              console.error('Hover video play failed:', error);
            }
          });
        };

        if (this.video.readyState > 0) {
          play();
        } else {
          this.video.addEventListener('loadeddata', play, { once: true });
        }
      }

      onEnter() {
        this.hoverWrap?.classList.remove('hidden');
        this.playBtn?.classList.add('is-hidden');
        this.playVideo();
      }

      onLeave() {
        this.hoverWrap?.classList.add('hidden');
        this.playBtn?.classList.remove('is-hidden');
        if (!this.video.paused) {
          this.video.pause();
          this.video.currentTime = 0;
        }
      }
    }

    customElements.define('gb-video-review-item-v1', GbVideoReviewItemV1);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-added-cart-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-added-cart-notice')) {
    class ProductAddedCartNotice extends HTMLElement {
      connectedCallback() {
        this.valueInput = this.querySelector('[data-notice-value]');
        this.targetSelector = this.dataset.targetSelector?.trim();
        this.insertPosition = this.dataset.insertPosition === 'prepend' ? 'prepend' : 'append';
        this.displayDuration = Number.parseInt(this.dataset.displayDuration, 10) || 5000;
        this.activeBubble = null;
        this.collapseTimer = null;
        this.removeTimer = null;

        if (!this.targetSelector || !this.valueInput?.value?.trim()) return;

        this.onAddToCartSuccess = this.onAddToCartSuccess.bind(this);
        document.addEventListener('lx-add-to-cart:success', this.onAddToCartSuccess);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event?.source === 'product-form') {
              this.onAddToCartSuccess();
            }
          });
        }
      }

      disconnectedCallback() {
        document.removeEventListener('lx-add-to-cart:success', this.onAddToCartSuccess);
        this.cartUpdateUnsubscriber?.();
        this.clearTimers();
        this.removeActiveBubble();
      }

      onAddToCartSuccess() {
        const value = this.valueInput?.value?.trim();
        if (!value) return;

        const target = this.findTarget();
        if (!target) return;

        this.showNotice(target, value);
      }

      findTarget() {
        const scope = this.closest('.lx-product') || this.closest('section') || document;
        return scope.querySelector(this.targetSelector) || document.querySelector(this.targetSelector);
      }

      showNotice(target, value) {
        this.clearTimers();
        this.removeActiveBubble();

        const bubble = document.createElement('span');
        bubble.className = 'lx-product-added-cart-notice__bubble';
        bubble.dataset.insertPosition = this.insertPosition;
        bubble.setAttribute('role', 'status');
        bubble.setAttribute('aria-live', 'polite');
        const inner = document.createElement('span');
        inner.className = 'lx-product-added-cart-notice__bubble-inner';
        inner.style.backgroundColor = this.dataset.noticeBubbleBgColor;
        inner.style.color = this.dataset.noticeBubbleTextColor;
        inner.textContent = value;
        bubble.append(inner);

        if (this.insertPosition === 'prepend') {
          target.prepend(bubble);
        } else {
          target.append(bubble);
        }

        this.activeBubble = bubble;

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            bubble.classList.add('is-expanded');
          });
        });

        this.collapseTimer = window.setTimeout(() => {
          this.collapseNotice(bubble);
        }, this.displayDuration);
      }

      collapseNotice(bubble) {
        if (!bubble?.isConnected) return;

        bubble.classList.remove('is-expanded');
        bubble.classList.add('is-collapsing');

        const onTransitionEnd = (event) => {
          if (event.target !== bubble && event.target !== bubble.firstElementChild) return;
          bubble.removeEventListener('transitionend', onTransitionEnd);
          bubble.remove();
          if (this.activeBubble === bubble) {
            this.activeBubble = null;
          }
        };

        bubble.addEventListener('transitionend', onTransitionEnd);

        this.removeTimer = window.setTimeout(() => {
          bubble.removeEventListener('transitionend', onTransitionEnd);
          bubble.remove();
          if (this.activeBubble === bubble) {
            this.activeBubble = null;
          }
        }, 600);
      }

      clearTimers() {
        if (this.collapseTimer) {
          window.clearTimeout(this.collapseTimer);
          this.collapseTimer = null;
        }
        if (this.removeTimer) {
          window.clearTimeout(this.removeTimer);
          this.removeTimer = null;
        }
      }

      removeActiveBubble() {
        this.activeBubble?.remove();
        this.activeBubble = null;
      }
    }

    customElements.define('product-added-cart-notice', ProductAddedCartNotice);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-extra-bundle"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const checkbox = event.target.closest('.lx-product-extra-bundle-block__checkbox');
    if (!checkbox || checkbox.disabled) return;

    const item = checkbox.closest('[data-promotion-pack]');
    if (!item) return;

    item.classList.toggle('selected', checkbox.checked);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-gallery"] && !Shopify.designMode) return;
  try {
    class LXProductGallery extends HTMLElement {
    static MOBILE_BREAKPOINT = 1024;

    constructor() {
      super();
      this._mainSwiper = null;
      this._thumbSwiper = null;
      this._resizeTimer = null;
      this._resizeObserver = null;
      this._onResize = this.handleResize.bind(this);
      this._boundSyncThumbHeight = this.syncThumbHeight.bind(this);
      this._onThumbClick = this.handleThumbClick.bind(this);
      this._onProductDetailUpdated = this.handleProductDetailUpdated.bind(this);
      this._onZoomClick = this.handleZoomClick.bind(this);
      this._onZoomMouseLeave = this.handleZoomMouseLeave.bind(this);
    }

    connectedCallback() {
      this.thumbEl = this.querySelector('.lx-product-gallery-thumbs');
      this.mainEl = this.querySelector('.lx-product-gallery-main');
      this.mainWrapEl = this.querySelector('.lx-product-gallery-main-wrap');
      this.paginationEl = this.querySelector('.lx-product-gallery-pagination-bullets');
      this.counterCurrentEl = this.querySelector('.lx-product-gallery-counter-current');
      this.counterTotalEl = this.querySelector('.lx-product-gallery-counter-total');
      this.productDetailEl = this.closest('[data-product-detail]');

      if (!this.mainEl) return;

      this.bindZoomInteraction();
      this.thumbEl?.addEventListener('click', this._onThumbClick);
      this.productDetailEl?.addEventListener(
        'lx-variant-selector-v1:product-detail-updated',
        this._onProductDetailUpdated
      );
      window.addEventListener('resize', this._onResize);
      this.waitForSwiperAndInit();
    }

    disconnectedCallback() {
      this.unbindZoomInteraction();
      this.thumbEl?.removeEventListener('click', this._onThumbClick);
      this.productDetailEl?.removeEventListener(
        'lx-variant-selector-v1:product-detail-updated',
        this._onProductDetailUpdated
      );
      window.removeEventListener('resize', this._onResize);
      clearTimeout(this._resizeTimer);
      this._resizeObserver?.disconnect();
      this._resizeObserver = null;
      this.destroySwipers();
    }

    get SwiperCtor() {
      return window.Swiper;
    }

    get isMobile() {
      return window.innerWidth <= LXProductGallery.MOBILE_BREAKPOINT;
    }

    waitForSwiperAndInit(attempt = 0) {
      if (this.SwiperCtor) {
        this.initGallery();
        return;
      }
      if (attempt > 50) return;
      requestAnimationFrame(() => this.waitForSwiperAndInit(attempt + 1));
    }

    handleResize() {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => this.initGallery(), 200);
    }

    destroySwipers() {
      this._mainSwiper?.destroy(true, true);
      this._thumbSwiper?.destroy(true, true);
      this._mainSwiper = null;
      this._thumbSwiper = null;
    }

    syncThumbHeight() {
      if (!this.mainEl) return;
      const mainHeight = this.mainEl.offsetHeight;
      if (mainHeight > 0) {
        this.style.setProperty('--main-gallery-height', `${mainHeight}px`);
        this._thumbSwiper?.update();
      }
    }

    updateSlideCounter(swiper) {
      if (!this.counterCurrentEl || !this.counterTotalEl) return;

      const total = swiper?.slides?.length ?? this.mainEl?.querySelectorAll('.swiper-slide')?.length ?? 0;
      const current = total > 0 ? (swiper?.activeIndex ?? 0) + 1 : 0;

      this.counterCurrentEl.textContent = current;
      this.counterTotalEl.textContent = total;
    }

    updateOnlyFirstImageVisibility(swiper) {
      if (!this.mainWrapEl?.querySelector('.only-first-image')) return;

      const isFirst = (swiper?.activeIndex ?? 0) === 0;
      this.mainWrapEl.classList.toggle('is-not-first-slide', !isFirst);
    }

    getMobileScrollOffset() {
      const barEl = document.querySelector('.shopify-section.alp-announcement-bar-section');
      const headerEl = document.querySelector('.shopify-section.alp-header-section');
      return (barEl?.offsetHeight || 0) + (headerEl?.offsetHeight || 0);
    }

    scrollToGalleryOnMobile() {
      if (!this.isMobile || this.getGalleryIndex() > 0) return;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const target = this.closest('.lx-product-gallery-block') || this;
          const rect = target.getBoundingClientRect();
          const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
          const offset = this.getMobileScrollOffset() + 20;

          window.scrollTo({
            top: Math.max(rect.top + scrollTop - offset, 0),
            behavior: 'smooth',
          });
        });
      });
    }

    handleThumbClick(event) {
      if (!this._mainSwiper || this.isMobile) return;
      const slide = event.target.closest('.swiper-slide');
      if (!slide || !this.thumbEl?.contains(slide)) return;
      const index = Array.from(this.thumbEl.querySelectorAll('.swiper-slide')).indexOf(slide);
      if (index >= 0) this._mainSwiper.slideTo(index);
    }

    bindZoomInteraction() {
      if (!this.mainWrapEl) return;
      this.unbindZoomInteraction();
      this.mainWrapEl.addEventListener('click', this._onZoomClick);
      this.mainWrapEl.addEventListener('mouseleave', this._onZoomMouseLeave);
    }

    unbindZoomInteraction() {
      this.mainWrapEl?.removeEventListener('click', this._onZoomClick);
      this.mainWrapEl?.removeEventListener('mouseleave', this._onZoomMouseLeave);
    }

    clearZoomActive() {
      this.mainWrapEl?.querySelectorAll('.lx-product-media-item-zoom.active').forEach((el) => {
        el.classList.remove('active');
      });
    }

    handleZoomClick(event) {
      if (this.isMobile) return;
      const mediaEl = event.target.closest('[data-media-id]');
      if (!mediaEl || !this.mainWrapEl?.contains(mediaEl)) return;

      const zoomEl = mediaEl.querySelector('.lx-product-media-item-zoom');
      if (!zoomEl) return;

      if (zoomEl.classList.contains('active')) {
        zoomEl.classList.remove('active');
        return;
      }

      this.clearZoomActive();
      zoomEl.classList.add('active');
    }

    handleZoomMouseLeave() {
      this.clearZoomActive();
    }

    getGalleryIndex() {
      if (!this.productDetailEl) return 0;
      return Array.from(this.productDetailEl.querySelectorAll('lx-product-gallery')).indexOf(this);
    }

    getUpdatedGallery(html) {
      if (!html) return null;

      const productId = this.productDetailEl?.dataset.productId;
      const selector =
        productId && window.CSS?.escape
          ? `[data-product-detail][data-product-id="${CSS.escape(productId)}"]`
          : '[data-product-detail]';
      const nextProductDetail = html.querySelector(selector) || html.querySelector('[data-product-detail]');
      const nextGalleries = nextProductDetail
        ? nextProductDetail.querySelectorAll('lx-product-gallery')
        : html.querySelectorAll('lx-product-gallery');
      const nextGalleryIndex = Math.max(this.getGalleryIndex(), 0);

      return nextGalleries[nextGalleryIndex] || nextGalleries[0] || null;
    }

    replaceSwiperWrapper(currentSwiperEl, nextSwiperEl) {
      const currentWrapper = currentSwiperEl?.querySelector('.swiper-wrapper');
      const nextWrapper = nextSwiperEl?.querySelector('.swiper-wrapper');
      if (!currentWrapper || !nextWrapper) return false;

      currentWrapper.innerHTML = nextWrapper.innerHTML;
      return true;
    }

    getVariantSlideIndex(variant) {
      if (!variant?.id || !this.mainEl) return -1;

      const variantId = String(variant.id);
      return Array.from(this.mainEl.querySelectorAll('.swiper-slide')).findIndex((slide) => {
        const variants = slide.dataset.variants;
        if (!variants) return false;

        return variants
          .split(',')
          .map((id) => id.trim())
          .includes(variantId);
      });
    }

    slideToVariant(variant) {
      const slideIndex = this.getVariantSlideIndex(variant);
      if (slideIndex < 0) return;

      this._mainSwiper?.slideTo(slideIndex, 0, false);
      this._thumbSwiper?.slideTo(slideIndex, 0, false);
      this.syncThumbHeight();
    }

    handleProductDetailUpdated(event) {
      const nextGallery = this.getUpdatedGallery(event.detail?.html);
      if (!nextGallery) {
        this.scrollToGalleryOnMobile();
        return;
      }

      const mainUpdated = this.replaceSwiperWrapper(this.mainEl, nextGallery.querySelector('.lx-product-gallery-main'));
      const thumbsUpdated = this.replaceSwiperWrapper(
        this.thumbEl,
        nextGallery.querySelector('.lx-product-gallery-thumbs')
      );

      if (mainUpdated || thumbsUpdated) {
        this.initGallery();
        lazyLoadInstance.update();
      }

      this.slideToVariant(event.detail?.variant);
      this.scrollToGalleryOnMobile();
    }

    bindMainResizeObserver() {
      if (!this.mainEl || !('ResizeObserver' in window)) return;
      this._resizeObserver?.disconnect();
      this._resizeObserver = new ResizeObserver(() => {
        this.syncThumbHeight();
        this._mainSwiper?.update();
        this._thumbSwiper?.update();
      });
      this._resizeObserver.observe(this.mainEl);
    }

    prepareThumbImages() {
      if (!this.thumbEl) return;
      this.thumbEl.querySelectorAll('img').forEach((img) => {
        const dataSrc = img.getAttribute('data-src');
        if (dataSrc && !img.getAttribute('src')) {
          img.setAttribute('src', dataSrc);
        }
      });
    }

    initGallery() {
      const SwiperCtor = this.SwiperCtor;
      if (!SwiperCtor || !this.mainEl) return;

      this.destroySwipers();

      const isMobile = this.isMobile;

      if (!isMobile && this.thumbEl) {
        this.prepareThumbImages();
        this._thumbSwiper = new SwiperCtor(this.thumbEl, {
          direction: 'vertical',
          slidesPerView: 'auto',
          spaceBetween: 12,
          watchSlidesProgress: true,
          slideToClickedSlide: false,
          mousewheel: true,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: this.thumbEl.querySelector('.swiper-button-next'),
            prevEl: this.thumbEl.querySelector('.swiper-button-prev'),
          },
        });
      }

      const mainPrevEl = this.mainEl.querySelector('.lx-product-gallery-main-nav .swiper-button-prev');
      const mainNextEl = this.mainEl.querySelector('.lx-product-gallery-main-nav .swiper-button-next');

      const mainConfig = {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 400,
        observer: true,
        observeParents: true,
        noSwiping: true,
        noSwipingClass: 'swiper-no-swiping',
        navigation:
          mainPrevEl && mainNextEl
            ? {
                prevEl: mainPrevEl,
                nextEl: mainNextEl,
              }
            : undefined,
        thumbs:
          !isMobile && this._thumbSwiper
            ? {
                swiper: this._thumbSwiper,
                slideThumbActiveClass: 'swiper-slide-thumb-active',
              }
            : undefined,
        on: {
          init: (swiper) => {
            this.syncThumbHeight();
            this._thumbSwiper?.slideTo(swiper.activeIndex, 0);
            this.updateSlideCounter(swiper);
            this.updateOnlyFirstImageVisibility(swiper);
          },
          resize: this._boundSyncThumbHeight,
          slideChange: (swiper) => {
            this.clearZoomActive();
            this.syncThumbHeight();
            this._thumbSwiper?.slideTo(swiper.activeIndex);
            this.updateSlideCounter(swiper);
            this.updateOnlyFirstImageVisibility(swiper);
          },
          slideChangeTransitionEnd: this._boundSyncThumbHeight,
        },
      };

      if (isMobile && this.paginationEl) {
        mainConfig.pagination = {
          el: this.paginationEl,
          clickable: true,
        };
      }

      this._mainSwiper = new SwiperCtor(this.mainEl, mainConfig);

      this.syncThumbHeight();
      this.bindMainResizeObserver();

      this.mainEl.querySelectorAll('img').forEach((img) => {
        if (img.complete) return;
        img.addEventListener('load', this._boundSyncThumbHeight, { once: true });
      });

      requestAnimationFrame(() => {
        this.syncThumbHeight();
        this._mainSwiper?.update();
        this._thumbSwiper?.update();
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('lx-product-gallery')) {
      customElements.define('lx-product-gallery', LXProductGallery);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["swiper_group"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    class SwiperGroup extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        const autoplay = this.getAttribute('data-swiper-autoplay');
        const autoplayDelay = this.getAttribute('data-swiper-autoplay-delay');
        const autoplayConfig =
          autoplay === 'true'
            ? { delay: Number(autoplayDelay) || 5000, disableOnInteraction: false, pauseOnMouseEnter: true }
            : false;
        const speed = this.getAttribute('data-swiper-speed');
        const swiperId = this.getAttribute('data-swiper-id');
        const swiperGap = this.getAttribute('data-swiper-gap');
        const swiperGapTablet = this.getAttribute('data-swiper-gap-tablet');
        const swiperGapMobile = this.getAttribute('data-swiper-gap-mobile');
        const swiperSlidesPerView =
          this.getAttribute('data-swiper-slides-per-view') == 'auto'
            ? 'auto'
            : Number(this.getAttribute('data-swiper-slides-per-view'));
        const swiperSlidesPerViewTablet =
          this.getAttribute('data-swiper-slides-per-view-tablet') == 'auto'
            ? 'auto'
            : Number(this.getAttribute('data-swiper-slides-per-view-tablet'));
        const swiperSlidesPerViewMobile =
          this.getAttribute('data-swiper-slides-per-view-mobile') == 'auto'
            ? 'auto'
            : Number(this.getAttribute('data-swiper-slides-per-view-mobile'));
        const swiperLayoutDirection = this.getAttribute('data-swiper-layout-direction');
        const swiper = new Swiper(`.lx-swiper-group-swiper[data-swiper-id="${swiperId}"]`, {
          slidesPerView: swiperSlidesPerViewMobile,
          spaceBetween: Number(swiperGapMobile) || Number(swiperGap) || 12,
          direction: swiperLayoutDirection || 'horizontal',
          autoplay: autoplayConfig,
          speed: Number(speed) || 500,
          rewind: true,
          scrollbar: {
            el: `[data-swiper-id="${swiperId}"] .swiper-scrollbar`,
            draggable: true,
          },
          navigation: {
            nextEl: `[data-swiper-id="${swiperId}"] .swiper-button-next`,
            prevEl: `[data-swiper-id="${swiperId}"] .swiper-button-prev`,
          },
          pagination: {
            el: `[data-swiper-id="${swiperId}"] .swiper-pagination-bullets`,
            clickable: true,
          },
          breakpoints: {
            751: {
              slidesPerView: swiperSlidesPerViewTablet,
              spaceBetween: Number(swiperGapTablet) || Number(swiperGap) || 12,
            },
            1025: {
              slidesPerView: swiperSlidesPerView,
              spaceBetween: Number(swiperGap) || 12,
            },
          },
        });
      }
      disconnectedCallback() {
        const swiperId = this.getAttribute('data-swiper-id');
        const swiper = document.querySelector(`.lx-swiper-group-swiper[data-swiper-id="${swiperId}"]`);
        if (swiper) {
          swiper.destroy();
        }
      }
    }
    customElements.define('lx-swiper-group', SwiperGroup);
  });
  } catch(e) { console.error(e); }
})();

})();
